/*
    Global configurations of app
 */

global.env = process.env.REACT_APP_START_ENV;

export const ENV = {
   PROD:'prod',
   DEV:'dev',
   STAGING:'staging'
}

const dev_config = {
    backendDomain: 'https://dev.sr-dashboard.com',
    frontendDomain: 'https://cl.sr-dashboard.com',
    reCaptchaSiteKey: '6LeXD6cZAAAAAJO_FosZvIrtrgvjq0aFa5guYq_j',
    stripePublicKey: 'pk_test_GcnxNBdVqZGrSm9aX3FmInqq'
}

const staging_config = {
    backendDomain: 'https://staging.sr-dashboard.com',
    frontendDomain: 'https://staging-client.sr-dashboard.com',
    reCaptchaSiteKey: '6LeXD6cZAAAAAJO_FosZvIrtrgvjq0aFa5guYq_j',
    stripePublicKey: 'pk_test_GcnxNBdVqZGrSm9aX3FmInqq'
}

const prod_config = {
    backendDomain: 'https://sr-dashboard.com',
    frontendDomain: 'https://dashboard.sprintray.com',
    reCaptchaSiteKey: '6Ldqk3MUAAAAABe6QLnRq-vcy_cKQutBvH7gr5Is',
    stripePublicKey: 'pk_live_SooMXThIJG1kOQqTV9R2dBGY'
}

export const localDev = false;

// AUDIT: use https: protocol to secure request?
if (global.env === ENV.PROD) {
    var env_config = prod_config;
} 
else if (global.env === ENV.STAGING) {
    var env_config = staging_config;
}
else {
    var env_config = dev_config;
}

export const backendDomain = localDev ? 'http://localhost:3001' : env_config.backendDomain;
export const frontendDomain = localDev ? 'http://localhost:3000' : env_config.frontendDomain;
export const reCaptchaSiteKey = localDev ? '6LeXD6cZAAAAAJO_FosZvIrtrgvjq0aFa5guYq_j' : env_config. reCaptchaSiteKey;
export const stripePublicKey = env_config.stripePublicKey;

// AUDIT: use wss: protocol to secure web socket?
export const backendSocketUrl = localDev ? backendDomain.replace(/^http/i, 'ws') : backendDomain.replace(/^https/i, 'wss') + ':8080';



// WEBPACK FOOTER //
// ./src/modules/configs.js